/* eslint-disable camelcase */
import { ENVIRONMENT, IUser } from 'shared/model';
import { create } from 'zustand';
import { userApi } from '../api';
import { getCookie } from 'shared/lib';

type Store = {
  user: IUser | null;
  isLoading: boolean;
};

type Action = {
  me: () => Promise<void>;
};

export const userStore = create<Store & Action>()((set) => ({
  isLoading: true,
  user: null,
  me: async () => {
    set({ isLoading: true });
    try {
      if (!getCookie(`${ENVIRONMENT}2_yepic_access_token`)) {
        return;
      }

      const user = await userApi.me();
      set({
        user
      });
    } catch (error) {
      set({ user: null });
      console.error('chat /me error: ', error);
    } finally {
      set({ isLoading: false });
    }
  }
}));

export const fullNameSelector = (state: Store) => {
  if (!state.user) return '';
  const { first_name = '', last_name = '' } = state.user;
  return `${first_name} ${last_name}`.trim();
};
